import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_PUBLISHEDGAMES,
} from './constants';

export default class PublishedGames {
  static getAll() {
    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_PUBLISHEDGAMES}?order=lastopened%20DESC`,
    }).catch((err) => {
      throw new Error(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/PublishedGames.js